import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import LivePagesByLineLastUpdatedQuery, {
	type LivePagesByLineLastUpdatedQuery$data,
	type LivePagesByLineLastUpdatedQuery$variables,
} from './by-line/__generated__/LivePagesByLineLastUpdatedQuery.graphql.ts';

export function preloadLastUpdated(contentId: any, useCache: any) {
	return query<LivePagesByLineLastUpdatedQuery$data, LivePagesByLineLastUpdatedQuery$variables>({
		query: LivePagesByLineLastUpdatedQuery,
		variables: {
			contentId,
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
}
